export const GLOBAL_CONSTANTS = {
  DEFAULT_ERROR: 'Something went wrong. Please try again later.',
  ERROR_CODE: {
    LIMIT: 'ReachThreshold',
    EXPIRE_TOKEN: 'ExpiredAuthToken',
    INVALID_TOKEN: 'InvalidAuthToken'
  },
  PLANS: {
    'free': {
      id: 1,
      code: 'free'
    },
    'launch': {
      id: 2,
      code: 'launch'
    },
    'universe': {
      id: 3,
      code: 'universe'
    },
    'pay-as-you-go': {
      id: 4,
      code: 'pay-as-you-go'
    }
  }
}